import script from "./DashboardFreezeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardFreezeModal.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardFreezeModal.vue?vue&type=style&index=0&id=ecb275a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecb275a8"]])

export default __exports__